import React from "react";
import PropTypes from "prop-types";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { OptimizelyProvider } from "@optimizely/react-sdk";

import { ApplicationWrapper } from "containers/ApplicationWrapper";
import { ErrorBoundary } from "./ApplicationWrapper/Bugsnag";
import "../main.scss";

const App = ({ store, optimizelyClient, optimizelyUser }) => {
	const {
		user: { visitId }
	} = store.getState();
	const user = optimizelyUser || { id: visitId };

	return (
		<Provider store={store}>
			<OptimizelyProvider
				optimizely={optimizelyClient}
				user={user}
			>
				<ErrorBoundary>
					<BrowserRouter>
						<ApplicationWrapper />
					</BrowserRouter>
				</ErrorBoundary>
			</OptimizelyProvider>
		</Provider>
	);
};

App.propTypes = {
	store: PropTypes.object.isRequired,
	optimizelyClient: PropTypes.object,
	optimizelyUser: PropTypes.shape({
		id: PropTypes.string,
		attributes: PropTypes.object
	})
};

App.defaultProps = {
	optimizelyClient: null,
	optimizelyUser: null
};

export default App;
